import { render, staticRenderFns } from "./editorRelatorio.vue?vue&type=template&id=f2ff1604&scoped=true"
import script from "./editorRelatorio.vue?vue&type=script&lang=js"
export * from "./editorRelatorio.vue?vue&type=script&lang=js"
import style0 from "./editorRelatorio.vue?vue&type=style&index=0&id=f2ff1604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ff1604",
  null
  
)

export default component.exports